var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-row',{staticClass:"ma-0",attrs:{"dense":""}},[_vm._t("default")],2),(!_vm.hideBorder)?_c('v-divider',{staticClass:"my-1"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }